import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const dashboardAPI = createApi({
  reducerPath: "dashboardAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: (params) => {
        return {
          url: `api/accounts/dashboard/`,
          params,
        };
      },
    }),

    getMainSearch: builder.query({
      query: (params) => {
        return {
          url: `api/accounts/dashboard/dashboard_search/`,
          params,
        };
      },
    }),
    getNotification: builder.query({
      query: (params) => {
        return {
          url: `/api/accounts/notifications/`,
          params,
        };
      },
    }),
    getQwikConfig: builder.query({
      query: (params) => {
        return {
          url: `/api/accounts/dashboard/quick-commerce-config/`,
          params,
        };
      },
    }),
    updateQwikConfig: builder.mutation({
      query: (params) => {
        return {
          url: `/api/accounts/dashboard/quick-commerce-config/`,
          method: "PATCH",
          body: params,
        };
      },
    }),
  }),
});

export const { useLazyGetDashboardQuery, useLazyGetMainSearchQuery,useLazyGetNotificationQuery, useLazyGetQwikConfigQuery, useUpdateQwikConfigMutation } =
  dashboardAPI;

export default dashboardAPI;
